module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start",
    class: _vm.relatorioCotacao ? 'detalhe-item-container-cotacao' : 'detalhe-item-container'
  }, [_c('div', {
    staticClass: "row-flex centered-between detalhe-titulo",
    class: _vm.removidoManual ? 'detalhe-titulo-removido-manual' : ''
  }, [_c('div', {
    staticClass: "row-flex centered-start gap-10"
  }, [_c('i', {
    staticClass: "item-detalhe-icone fa fa-arrow-circle-right"
  }), _vm._v(" Detalhamento de Item de Licitação [" + _vm._s(_vm.itemLicitacao['id']) + "]\n    ")]), _vm._v(" "), (!_vm.relatorioCotacao) ? _c('i', {
    staticClass: "item-detalhe-icone button-icone fa fa-remove",
    on: {
      "click": function($event) {
        return _vm.toggleDetalhe(false)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.itemLicitacao['descricao_lote'] !== '0' && _vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Descrição Lote",
      "value": _vm.itemLicitacao['descricao_lote'],
      "icone": "fa-bars"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Produto",
      "value": _vm.itemLicitacao['descricao_item'],
      "icone": "fa-cube"
    }
  })], 1), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Descrição Adicional",
      "value": _vm.itemLicitacao['descricao_simplificada_item'],
      "icone": "fa-cubes"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Valor do Item",
      "value": _vm.itemLicitacao['valor_item'],
      "formatarValor": true,
      "icone": "fa-dollar"
    }
  })], 1), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Quantidade Aprovada",
      "value": _vm.itemLicitacao['quantidade_item_aprovado'],
      "icone": "fa-tags"
    }
  }), _vm._v(" "), _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Valor do Lote",
      "value": _vm.itemLicitacao['valor_total_lote_item'],
      "formatarValor": true,
      "icone": "fa-money"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Licitação",
      "value": _vm.itemLicitacao['codigo_licitacao'],
      "icone": "fa-balance-scale"
    }
  }), _vm._v(" "), _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Data Licitação",
      "value": _vm.moment.utc(_vm.itemLicitacao['data_resultado_licitacao']).format('MM/YYYY'),
      "icone": "fa-calendar"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['sigla_uf'] !== '0' && _vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "UF",
      "value": _vm.itemLicitacao['sigla_uf'],
      "icone": "fa-map"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('a', {
    staticClass: "row-flex start-centered detalhe-item-row",
    attrs: {
      "href": _vm.linkLicitacao(_vm.itemLicitacao['nome_fonte_dado']),
      "target": "_blank"
    }
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Fonte de Dados",
      "value": _vm.itemLicitacao['nome_fonte_dado'],
      "icone": "fa-commenting",
      "link": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Fornecedor",
      "value": _vm.itemLicitacao['nome_fornecedor'],
      "icone": "fa-cog"
    }
  }), _vm._v(" "), _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "CNPJ Fornecedor",
      "value": _vm.itemLicitacao['codigo_cnpj_fornecedor'],
      "icone": "fa-cogs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [_c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Comprador",
      "value": _vm.itemLicitacao['nome_orgao_comprador'],
      "icone": "fa-shopping-cart"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
    staticClass: "row-flex start-centered detalhe-item-row"
  }, [(_vm.itemLicitacao['nome_setor_item'] !== '0') ? _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Setor",
      "value": _vm.itemLicitacao['nome_setor_item'],
      "icone": "fa-object-group"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_categoria_item'] !== '0') ? _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Categoria",
      "value": _vm.itemLicitacao['nome_categoria_item'],
      "icone": "fa-sliders"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_grupo_item'] !== '0') ? _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Grupo",
      "value": _vm.itemLicitacao['nome_grupo_item'],
      "icone": "fa-sort-alpha-asc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_classificacao_item'] !== '0') ? _c('itemDetalheLicitacao', {
    attrs: {
      "titulo": "Classificação",
      "value": _vm.itemLicitacao['nome_classificacao_item'],
      "icone": "fa-tasks"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioCotacao) ? _c('div', {
    staticClass: "row-flex all-end detalhe-rodape"
  }, [_vm._v("\n    0" + _vm._s(_vm.index) + " / 0" + _vm._s(_vm.total) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-963d7b5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/detalheItemLicitacao.vue
// module id = 2041
// module chunks = 1